import { api } from "./api";

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isAndroid = () => /android/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export function registerSW() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
  }
}

function urlB64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function getSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Dein Browser unterstützt keine Push-Benachrichtigungen. Auf dem iPhone: App zuerst zum Home-Bildschirm hinzufügen.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Benachrichtigungen wurden nicht erlaubt. Bitte in den Einstellungen freigeben.");
  const reg = (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8Array(data.key) });
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  window.dispatchEvent(new Event("push-changed"));
  return sub;
}

export async function disablePush() {
  const sub = await getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
    await sub.unsubscribe();
    window.dispatchEvent(new Event("push-changed"));
  }
}

let installEvent = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); installEvent = e; window.dispatchEvent(new Event("install-available")); });
}
export const canInstall = () => !!installEvent;
export async function promptInstall() {
  if (!installEvent) return false;
  installEvent.prompt();
  const { outcome } = await installEvent.userChoice;
  installEvent = null;
  return outcome === "accepted";
}

const IN_APP = /Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly|Snapchat|Line\/|Twitter|LinkedInApp/i;
const IOS_OTHER_BROWSER = /CriOS|FxiOS|EdgiOS|OPiOS/i;

export function detectDevice() {
  const ua = navigator.userAgent;
  const os = isIOS() ? "ios" : isAndroid() ? "android" : "desktop";
  const standalone = isStandalone();
  const permission = "Notification" in window ? Notification.permission : "unsupported";
  let kind;
  if (IN_APP.test(ua)) kind = `${os === "ios" ? "ios" : "android"}-inapp`;
  else if (os === "ios" && IOS_OTHER_BROWSER.test(ua)) kind = "ios-inapp";
  else if (os === "ios" && !standalone) kind = "ios-install";
  else if (!pushSupported()) kind = "unsupported";
  else if (permission === "denied") kind = "denied";
  else kind = os === "ios" ? "ios-ready" : os;
  const label = { ios: "iPhone/iPad", android: "Android", desktop: "Computer" }[os];
  return { os, label, kind, standalone, permission };
}
